// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage as firebaseOnMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_RECEIVER_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_RECEIVER_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_RECEIVER_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_RECEIVER_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_RECEIVER_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_RECEIVER_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_RECEIVER_MEASUREMENT_ID
};

const isMessagingSupported = "serviceWorker" in navigator;

const app = initializeApp(firebaseConfig);
const messaging = isMessagingSupported ? getMessaging(app) : null;

const requestToken = async () => {
  if (!messaging) {
    console.warn("Firebase Messaging is not supported in this browser (no Service Worker support).");
    return null;
  }

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_RECEIVER_VAPID_KEY,
    });

    if (currentToken) {
      return currentToken;
    } else {
      throw new Error("Gagal mendapatkan token. Pastikan izin diberikan.");
    }
  } catch (error) {
    throw new Error("Terjadi kesalahan: " + error.message);
  }
};

const onMessage = (messagingInstance, callback) => {
  if (!messagingInstance) {
    console.warn("Firebase Messaging is not supported; onMessage listener skipped.");
    return () => {};
  }
  return firebaseOnMessage(messagingInstance, callback);
};

export const registerServiceWorker = () => {
  if (isMessagingSupported) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Service Worker registered successfully:", registration);
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  }
};
export { messaging, requestToken, onMessage };
